window.addEventListener('load', function () {
  if (!document.cookie.includes('cookies_consent_disabled') && sessionStorage.getItem('nocook') !== 'nocook') {
    window.cookieConsent = initCookieConsent();
    window.cookieConsent.run({
      current_lang: 'cs',
      autoclear_cookies: true, // default: false
      theme_css: '',
      page_scripts: true, // default: false
      gui_options: {
        consent_modal: {
          layout: 'cloud', // box/cloud/bar
          position: 'bottom center', // bottom/middle/top + left/right/center
          transition: 'slide', // zoom/slide
          swap_buttons: false, // enable to invert buttons
        },
        settings_modal: {
          layout: 'box', // box/bar
          // position: 'left',           // left/right
          transition: 'slide', // zoom/slide
        },
      },
      languages: {
        cs: {
          consent_modal: {
            title: 'Používáme cookies!',
            description:
              'Dobrý den, tato stránka používá cookies pro nezbytné účely, ale taky abychom pochopili jak jste s naší stránkou spokojeni. <button type="button" data-cc="c-settings" class="cc-link">Nastavení</button>',
            primary_btn: {
              text: 'Přijmout vše',
              role: 'accept_all', // 'accept_selected' or 'accept_all'
            },
            secondary_btn: {
              text: 'Odmítnout vše',
              role: 'accept_necessary', // 'settings' or 'accept_necessary'
            },
          },
          settings_modal: {
            title: 'Nastavení',
            save_settings_btn: 'Uložit nastavení',
            accept_all_btn: 'Přijmout vše',
            reject_all_btn: 'Odmítnout vše',
            close_btn_label: 'Zavřít',
            cookie_table_headers: [{ col1: 'Název' }, { col2: 'Doména' }, { col3: 'Expirace' }, { col4: 'Popis' }],
            blocks: [
              {
                title: 'Jak používáme cookies 📢',
                description: 'Cookies používáme k zajištění základních funkcí webu a také k zlepšení Vašeho zážitku.',
              },
              {
                title: 'Nezbytné cookies',
                description: 'Tyto cookies jsou nezbytné pro správnou činnost webu. Bez těchto cookies nemůže stránka fungovat správně.',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
                },
                cookie_table: [
                  // list of all expected cookies
                  {
                    col1: 'PHPSESSID',
                    col2: window.location.hostname,
                    col3: 'Session',
                    col4: 'Soubor cookie generovaný aplikacemi založenými na jazyce PHP. Jedná se o univerzální identifikátor používaný k udržování proměnných relace uživatele. Obvykle se jedná o náhodně vygenerované číslo, způsob jeho použití může být specifický pro daný web, ale dobrým příkladem je udržování stavu přihlášení uživatele mezi stránkami.',
                  },
                  {
                    col1: 'cc_cookie',
                    col2: window.location.hostname,
                    col3: 'Session',
                    col4: 'Uložení současného rozhodnutí nastavení cookies na tomto webu.',
                  },
                ],
              },
              {
                title: 'Analytické cookies',
                description: 'Slouží pro zapamatování si Vašich rozhodnutí v minulosti.',
                toggle: {
                  value: 'analytics', // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [
                  // list of all expected cookies
                  {
                    col1: '^_ga', // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '2 roky',
                    col4: 'Tento název souboru cookie je spojen se službou Google Universal Analytics, což je významná aktualizace běžněji používané analytické služby společnosti Google. Tento soubor cookie se používá k rozlišení jedinečných uživatelů přiřazením náhodně vygenerovaného čísla jako identifikátoru klienta. Je obsažen v každém požadavku na stránku na webu a slouží k výpočtu údajů o návštěvnících, relacích a kampaních pro analytické přehledy webu.',
                    is_regex: true,
                  },
                  {
                    col1: '_gid',
                    col2: 'google.com',
                    col3: '1 den',
                    col4: 'Store and count pageviews',
                  },
                ],
              },
              {
                title: 'Reklamní cookies',
                description:
                  'Cookies zaznamenavající použití informací jak interagujete se stránkou, jaké stránky jste navštívili a na co klikáte. Všechny data jsou anonymizované a nejde je zneužít pro Vaši identifikaci.',
                toggle: {
                  value: 'targeting',
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [
                  {
                    col1: 'YSC',
                    col2: '.youtube.com',
                    col3: 'Session',
                    col4: 'Tento soubor cookie je nastaven službou YouTube ke sledování zobrazení vložených videí.',
                  },
                  {
                    col1: 'VISITOR_INFO1_LIVE',
                    col2: '.youtube.com',
                    col3: '6 měsíců',
                    col4: 'Tento soubor cookie je nastaven společností Youtube za účelem sledování uživatelských preferencí pro videa Youtube vložená do stránek; může také určit, zda návštěvník webových stránek používá novou nebo starou verzi rozhraní Youtube.',
                  },
                ],
              },
              {
                title: 'Více informací',
                description:
                  'Pokud máte dotazy ohledně cookies nebo čehokoli jiného, <a class="cc-link" href="#">kontaktujte nás přímo</a>.',
              },
            ],
          },
        },
      },
    });
  }
});
